





























































import {Component, Prop} from 'vue-property-decorator'
import {SubscriptionPlan, Rate} from '@/lib/kepler/interfaces'
import DateHelper from '@/lib/DateHelper'
import collect from 'collect.js'
import moment from 'moment'
import Utils from '@/utils'

import GradientCard from '../GradientCard.vue'
import {State} from 'vuex-class'

@Component({
  components: {
    Layout: Utils.loadComponent('proxy/Layout'),
    Flex: Utils.loadComponent('proxy/Flex'),
    CustomIcon: Utils.loadComponent('CustomIcon'),
    Icon: Utils.loadComponent('proxy/Icon'),
    GradientCard,
  },
})
export default class CardPlan extends GradientCard {
  @Prop({
  }) private plan!: SubscriptionPlan
  @State((state) => state.configuration.appConfig.fields_configuration.hide_free_plan_string) private hideFree?: string

  private get minPlan() {
    const rates: Rate[] = this.plan.rates
    if (this.plan && rates && rates.length > 0) {
      const c = collect(rates)
      return c.sortBy('time_rate.time_cost').first()
    }
  }
  private get cycle() {
    return moment.duration(this.plan.billing_cycle, 'days').humanize()
  }
  private get duration() {
    const d = this.plan.duration
    switch (this.plan.duration) {
      case 30:
        return this.$t('activities.plans.card.duration.monthly')
      case 60:
        return this.$t('activities.plans.card.duration.two-monthly')
      case 90:
        return this.$t('activities.plans.card.duration.quarterly')
      case 365:
        return this.$t('activities.plans.card.duration.annual')
      default:
        if (d > 3000) {
          return this.$t('activities.plans.card.duration.unlimited')
        } else if (!(d % 30)) {
          return this.$t('activities.plans.card.duration.months', {n: d / 30})
        } else {
          return this.$t('activities.plans.card.duration.days', {n: d})
        }
    }
  }

  private get rates(): Rate[] | null {
    return this.plan ? this.plan.rates : null
  }

  private get planVehicleTypes() {
    if (this.rates) {
      const t: any[] = []
      for (const rate of this.rates) {
        const type = rate.vehicle_category.type
        if (!t.includes(type)) {
          t.push(type)
        }
      }
      return t
    }
    return null
  }

  private parseDays(val: number) {
    return DateHelper.parseMinutes(this, val * 1440)
  }
}
